import { render, staticRenderFns } from "./OpenFileList.vue?vue&type=template&id=596251e4&scoped=true"
import script from "./OpenFileList.vue?vue&type=script&lang=js"
export * from "./OpenFileList.vue?vue&type=script&lang=js"
import style0 from "./OpenFileList.vue?vue&type=style&index=0&id=596251e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596251e4",
  null
  
)

export default component.exports